export default __webpack_public_path__ + "static/media/section17.7e22f2b8.png";